<template>
  <f7-block>
    <div
      v-if="selectedAccessDevice != null"
      class="content-dispositivo-acceso-header"
    >
      <div>
        <div>
          <span class="main-title">{{ selectedAccessDevice.Nombre }}</span>
          <img
            v-if="selectedAccessDevice.DispositivoEnIncidencia"
            class="img-iconoIndicadorIncidenciaDispositivo"
            src="@/static/icons/ic_warning.svg"
          >
        </div>
        <span>
          {{ selectedAccessDevice.ActividadProduccion.Nombre }}
        </span>
      </div>
    </div>
  </f7-block>
</template>

<script>
export default {
  name: 'PCAccessDeviceDetail',

  props: {
    selectedAccessDevice: { type: Object, default: null },
  },
};
</script>

<style lang="scss">
.content-dispositivo-acceso-header {
  display: flex;
  align-items: center;

  >div {
    margin-left: 15px;

    div {
      span {
        font-size: 16px;
        font-weight: 500;
      }
    }
  }
}
</style>
